import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiEdit2, FiChevronRight } from 'react-icons/fi';
import { IoLocationOutline } from 'react-icons/io5';
import { MdPayment, MdOutlineStorefront } from 'react-icons/md';
import { BiInfoCircle, BiPhoneCall } from 'react-icons/bi';
import { useAuth } from '../context/AuthContext';
import './Profile.css';

const Profile = () => {
    const { user, updateUserInfo } = useAuth();
    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(false);
    const [editName, setEditName] = useState(user?.name || '');
    const [editEmail, setEditEmail] = useState(user?.email || '');

    const menuItems = [
        {
            section: 'account',
            items: [
                { icon: <IoLocationOutline size={22} />, label: 'Addresses', path: '/addresses' },
                { icon: <MdPayment size={22} />, label: 'How to Order & Payment', path: '/payment' },
            ]
        },
        {
            section: 'support',
            items: [
                { icon: <BiInfoCircle size={22} />, label: 'About Us', path: '/about' },
                { icon: <BiPhoneCall size={22} />, label: 'Contact Us', path: '/contact' }
            ]
        },
        {
            section: 'seller',
            items: [
                { icon: <MdOutlineStorefront size={22} />, label: 'Seller Login', path: '/admin/login' }
            ]
        }
    ];

    const handleMenuClick = (path) => {
        navigate(path);
    };

    const handleEditProfile = () => {
        if (isEditing) {
            // Save changes
            updateUserInfo(editName, editEmail);
        }
        setIsEditing(!isEditing);
    };

    return (
        <div className="profile-page">
            <div className="profile-greeting">
                <h2>Welcome back, {user?.name || 'there'}! 👋</h2>
                <p className="greeting-tagline">Your style journey continues here</p>
            </div>
            
            <div className="profile-header">
                <div className="profile-avatar">
                    <div className="avatar-placeholder">
                        {user?.name?.charAt(0).toUpperCase() || 'U'}
                    </div>
                </div>
                
                {isEditing ? (
                    <div className="profile-edit-form">
                        <input
                            type="text"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                            placeholder="Your name"
                            className="edit-input"
                        />
                        <input
                            type="email"
                            value={editEmail}
                            onChange={(e) => setEditEmail(e.target.value)}
                            placeholder="Your email"
                            className="edit-input"
                        />
                    </div>
                ) : (
                    <div className="profile-info">
                        <h2>{user?.name || 'User'}</h2>
                        <p>{user?.email}</p>
                    </div>
                )}
                
                <button className="edit-profile-btn" onClick={handleEditProfile}>
                    <FiEdit2 size={18} />
                    {isEditing ? 'Save Profile' : 'Edit Profile'}
                </button>
            </div>

            <div className="profile-menu">
                {menuItems.map((section, idx) => (
                    <div key={idx} className="menu-section">
                        {section.items.map((item, itemIdx) => (
                            <div 
                                key={itemIdx} 
                                className="menu-item"
                                onClick={() => handleMenuClick(item.path)}
                            >
                                <div className="menu-item-left">
                                    <span className="menu-icon">{item.icon}</span>
                                    <span className="menu-label">{item.label}</span>
                                </div>
                                <FiChevronRight size={20} className="chevron-icon" />
                            </div>
                        ))}
                        {idx < menuItems.length - 1 && <div className="menu-divider"></div>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Profile;
